import React from 'react';
import { useSelector } from 'react-redux';
import raf from 'raf';
import { AlertDialog, Button, ButtonGroup, Content, Dialog, DialogContainer, Divider, Flex, Heading, useDialogContainer, } from '@adobe/react-spectrum';
import { Prompt as PromptActions } from 'app/stores/editor/prompt';
import { useAppDispatch } from 'app/stores/store';
import { Text } from 'app/views/components/typography/Text';
import { noop } from 'app/utils/function';
const Lines = (props) => (React.createElement(Flex, { direction: "column", gap: "size-50" }, props.text.split('\n').map(line => (React.createElement(Text, { key: line }, line)))));
const PromptContent = (props) => {
    const dispatch = useAppDispatch();
    const { prompt } = props;
    const { id, title, content, variant } = prompt;
    const { dismiss } = useDialogContainer();
    const createHandler = (result) => () => {
        dismiss();
        raf(() => {
            dispatch(PromptActions.close({ id, result }));
        });
    };
    switch (variant) {
        case 'prompt': {
            const { options } = prompt;
            return (React.createElement(Dialog, null,
                React.createElement(Heading, null, title),
                React.createElement(Divider, null),
                React.createElement(Content, null,
                    React.createElement(Lines, { text: content })),
                React.createElement(ButtonGroup, null,
                    React.createElement(Button, { variant: "secondary", onPress: createHandler('cancel') }, "Cancel"),
                    options.map(option => (React.createElement(Button, { key: option.id, variant: "accent", onPress: createHandler(option.id) }, option.label))))));
        }
        case 'confirmation': {
            return (React.createElement(AlertDialog, { "data-id": "prompt", variant: "confirmation", title: title, primaryActionLabel: "Yes", cancelLabel: "No", autoFocusButton: "primary", onPrimaryAction: createHandler(true), onCancel: createHandler(false) },
                React.createElement(Lines, { text: content })));
        }
        case 'error':
            return (React.createElement(AlertDialog, { "data-id": "prompt", variant: "error", title: title, primaryActionLabel: "I understand", autoFocusButton: "primary", onPrimaryAction: createHandler(true) },
                React.createElement(Lines, { text: content })));
        default:
            return null;
    }
};
export const Prompt = () => {
    const prompt = useSelector((state) => state.editor.prompt);
    if (!prompt) {
        return null;
    }
    return (React.createElement(DialogContainer, { isDismissable: false, isKeyboardDismissDisabled: false, onDismiss: noop },
        React.createElement(PromptContent, { prompt: prompt })));
};
